import { withFormsy } from 'formsy-react'
import _ from 'lodash';
import React, { Component } from 'react'

import './DGTextarea.less'
class DGTextarea extends Component {

    constructor(props) {
        super(props);

    }
    componentDidMount() {

    }

    changeValue = (event) => {
        this.props.setValue(event.currentTarget.value);
        if (this.props.onChange) {
            this.props.onChange(event, { name: this.props.name, value: event.currentTarget.value });
        }
        
    };

    render() {

        let inputClassName = '';

        if ((!this.props.isValid && !this.props.isPristine && this.props.isFormSubmitted) || (this.props.validExternally === false)) {
            inputClassName += 'error';
        }
        
        return (
            <div className="textarea-field">
                <textarea onChange={this.changeValue}
                    {...{
                        placeholder: this.props.placeholder ? this.props.placeholder : " ",
                        className: inputClassName,
                    }}
                    maxLength={this.props.maxLength ? this.props.maxLength: ''}
                    value={this.props.value}
                    defaultValue={this.props.defaultValue}
                    disabled={this.props.disabled}
                />
                 
                <div className="label"><span>{this.props.label}</span>
                    {this.props.placeholder && <span>({this.props.placeholder})</span>}
                    {!this.props.placeholder && <span></span>}
                </div>
                {((!this.props.isValid && !this.props.isPristine && this.props.isFormSubmitted) || (this.props.validExternally === false)) && <div className="error-label">{this.props.errorMessage || this.props.externalErrorMessage}</div>}
                {this.props.showRequired &&
                    <div className="required">*</div>
                }
            </div>
        )
    }
}

export default withFormsy(DGTextarea)
